module.exports = __webpack_public_path__ + "8f5187ad988e8534b09f6bf9e31b1a52.svg";